<template>
  <page>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New Department
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          v-bind:options.sync="pagination"
          item-key="name"
          :loading="loading"
          :no-data-text="noDataText"
          :custom-filter="customSearch"
        >
          <template v-slot:item="row"
            ><tr>
              <td class="text-xs-left">{{ row.item.dept }}</td>
              <td class="text-xs-left">{{ row.item.deptDesc }}</td>
              <td class="table-action-header">
                <table-action
                  :rowData="row"
                  query
                  @query="doQuery(row.item.dept)"
                  review
                  @review="doReview(row.item.dept)"
                  remove
                  @remove="doDelete(row.item.dept)"
                ></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="deptDialog" width="800px" persistent>
        <v-card :key="deptDialog">
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
            <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
            <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
            <v-toolbar-title v-if="tranMode === 'New'">New Department</v-toolbar-title>
            <v-toolbar-title v-if="tranMode === 'Review'">Edit Department</v-toolbar-title>
            <v-toolbar-title v-if="tranMode === 'Query'">View Existing Department</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6 v-if="tranMode === 'New'">
                  <v-text-field
                    :label="labels.dept"
                    v-model="deptForm.dept"
                    :error-messages="errors.collect('dept')"
                    data-vv-name="dept"
                    :data-vv-as="labels.dept"
                    v-validate="'required|param|max:1'"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="tranMode === 'Review' || tranMode === 'Query'">
                  <v-subheader class="queryLabel">{{ labels.dept }}</v-subheader>
                  <div class="queryValue">{{ deptForm.dept }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode === 'New' || tranMode === 'Review'">
                  <v-text-field
                    :label="labels.deptDesc"
                    v-model="deptForm.deptDesc"
                    :error-messages="errors.collect('deptDesc')"
                    data-vv-name="deptDesc"
                    :data-vv-as="labels.deptDesc"
                    v-validate="'required|entry|max:40'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-if="tranMode === 'Query'">
                  <v-subheader class="queryLabel">{{ labels.deptDesc }}</v-subheader>
                  <div class="queryValue">{{ deptForm.deptDesc }}</div>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6 v-if="glSys === 2 && (tranMode === 'New' || tranMode === 'Review')">
                  <v-autocomplete
                    :label="labels.glAc"
                    :items="glacList"
                    item-text="label"
                    item-value="value"
                    v-model="deptForm.glAc"
                    :error-messages="errors.collect('dri')"
                    data-vv-name="glAc"
                    :data-vv-as="labels.glAc"
                    v-validate="'required'"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 v-if="glSys === 2 && tranMode === 'Query'">
                  <v-subheader class="queryLabel">{{ labels.glAc }}</v-subheader>
                  <div class="queryValue" v-for="item in filterAccmTypeList" :key="item.label">{{ item.label }}</div>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                  <div class="queryValue">{{ deptForm.createdBy }}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                  <div class="queryValue">{{ deptForm.createdDate | formatDate }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode === 'Review' || tranMode === 'Query'">
                  <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                  <div class="queryValue">{{ deptForm.modifiedBy }}</div>
                </v-flex>
                <v-flex xs6 v-if="tranMode === 'Review' || tranMode === 'Query'">
                  <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                  <div class="queryValue">{{ deptForm.modifiedDate | formatDate }}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" text @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm ref="confirmDelete"> Are you sure you want to delete the selected Department? ({{ selectedDept }}) </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { mapGetters } from 'vuex'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      title: 'Department',
      headers: [{ text: 'Department', value: 'dept' }, { text: 'Description', value: 'deptDesc' }, TableConst.tableActionHeader],
      labels: {
        dept: 'Department',
        deptDesc: 'Description',
        glAc: 'GL Analysis Code',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      deptForm: {
        dept: null,
        deptDesc: null,
        glAc: null,
        createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedBy: null,
        modifiedDate: null
      },
      deptDialog: false,
      newDept: false,
      selectedDept: null,
      glSys: null,
      glacList: null,
      tranMode: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async loadGlacList() {
      const apiURI = this.menu.loadGlacList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.glSys = data.miscAcctParam.glSys
            if (this.glSys === 2) {
              this.glacList = data.glacList
              // this.deptForm.glAc = this.glacList[0].value
            }
          }
        } catch (err) {
          throw err
        }
      }
    },
    async doInit() {
      await this.loadGlacList()
      const apiURI = this.menu.getDeptList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          this.items = []
          const { data } = result.data
          if (data) {
            data.map((dept) => {
              const convertList = {
                dept: dept.dept,
                glAc: dept.glAc,
                deptDesc: dept.deptDesc
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doReview(dept) {
      const apiURI = this.menu.getDept
      if (apiURI) {
        const expand = {
          dept
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.deptForm.dept = data.dept.dept
              this.deptForm.deptDesc = data.dept.deptDesc
              this.deptForm.glAc = data.dept.glAc
              this.deptForm.createdBy = data.createdBy
              this.deptForm.createdDate = data.createdDate
              this.deptForm.modifiedBy = data.modifiedBy
              this.deptForm.modifiedDate = data.modifiedDate
              // this.newDept = false
              this.deptDialog = true
              this.tranMode = 'Review'
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doNew() {
      // this.newDept = true
      this.tranMode = 'New'
      this.deptDialog = true
      this.deptForm.dept = null
      this.deptForm.deptDesc = null
      if (this.glSys === 2) {
        this.deptForm.glAc = this.glacList[0].value
      } else {
        this.deptForm.glAc = null
      }
      this.deptForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.deptForm.createdDate = new Date()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if (this.newDept) {
          if (this.tranMode === 'New') {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      const apiURI = this.menu.createDept
      if (apiURI) {
        this.$http
          .post(apiURI, this.deptForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit()
              this.doClose()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doUpdate() {
      const apiURI = this.menu.updateDept
      if (apiURI) {
        this.$http
          .put(apiURI, this.deptForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit()
              this.doClose()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async checkDelete(dept) {
      if (dept) {
        const apiURI = this.menu.checkDeleteDept
        if (apiURI) {
          try {
            await this.$http.get(expandURI(apiURI, { dept }))
          } catch (err) {
            throw err
          }
        } else {
          throw Error('API not exist - checkDeleteDept')
        }
      } else {
        throw Error('Invalid dept')
      }
    },
    async doDelete(dept) {
      if (dept) {
        try {
          await this.checkDelete(dept)
          this.selectedDept = dept
          const confirm = await this.$refs.confirmDelete.doPopUp()
          if (confirm) {
            const apiURI = this.menu.deleteDept
            if (apiURI) {
              const result = await this.$http.delete(expandURI(apiURI, { dept }))
              const { data } = result
              this.notify(data)
              this.doInit()
            }
          }
        } catch (err) {
          if (err.response) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        }
      }
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      // this.newDept = false
      this.deptDialog = false
    },
    doQuery(dept) {
      const apiURI = this.menu.getDept
      if (apiURI) {
        const expand = {
          dept
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.deptForm.dept = data.dept.dept
              this.deptForm.deptDesc = data.dept.deptDesc
              this.deptForm.glAc = data.dept.glAc
              this.deptForm.createdBy = data.createdBy
              this.deptForm.createdDate = data.createdDate
              this.deptForm.modifiedBy = data.modifiedBy
              this.deptForm.modifiedDate = data.modifiedDate
              // this.newDept = false
              this.deptDialog = true
              this.tranMode = 'Query'
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    menu() {
      return this.$store.state.deptParam.menu
    },
    filterAccmTypeList() {
      return this.glacList.filter((list) => {
        return list.value === this.deptForm.glAc
      })
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
